/* eslint-disable no-unused-vars */
import React from "react";

import { ReactComponent as SearchIcon } from "assets/images/iconsV2/Search.svg";
import Input from "components/v2/Input/Input";

type ExpandableSearchProps = {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
};

function ExpandableSearch(props: ExpandableSearchProps) {
  const { value, onChange, placeholder } = props;

  return (
    <div className="mb-xl">
      <Input icon={<SearchIcon />} value={value} onChange={onChange} placeholder={placeholder} shouldUnregister />
    </div>
  );
}

export default ExpandableSearch;

ExpandableSearch.defaultProps = {
  placeholder: "Search...",
};
